
export const BASE_URL = process.env.REACT_APP_API_URL || '/api';
export const PHOTOS_BASE_URL = process.env.REACT_APP_PHOTOS_URL || 'https://davaynasvidanie.ru/img/';
